// Idle / Emperor messages — on the rail (ui/messageRail.js), URGENT so they jump the queue and stand until activity resumes:
//   the warning carries his countdown meter; the fines say what was taken. Activity dismisses them (idleManager emits IdleResume).

import { Events, on } from './eventBus.js'
import { postMessage, resolveMessage } from './messageRail.js'
import { pushLog } from './hud.js'
import { formatCoins } from './format.js'
import { IdleConfig } from '../config/balance.js'

export function mountIdlePanel() {
  let totalFined = 0
  on(Events.IdleWarn, ({ msUntilFine, emperor }) => {
    const secs = Math.ceil(msUntilFine / 1000)
    postMessage({ key: 'idle', kind: 'urgent', type: 'IDLE', icon: '👑', title: `The Emperor is watching · ${emperor.name} ${emperor.cn}`, text: emperor.warn,
      action: `Move the mouse, click or press any key within ${secs}s or the Emperor's tax-takers arrive.`,
      meter: { until: Date.now() + msUntilFine, total: IdleConfig.fineAfterMs - IdleConfig.warnAfterMs } })
  })
  on(Events.IdleFineInitial, ({ taken, emperor }) => {
    totalFined = taken
    postMessage({ key: 'idle', kind: 'urgent', type: 'IDLE', icon: '👑', title: `The Emperor demands his due · ${emperor.name} ${emperor.cn}`, text: emperor.scold,
      action: `The Emperor seized ${formatCoins(taken)} from your treasury. Your citizens slack off; tax tribute is intercepted. Move the mouse, click or press any key to stop it. Stolen so far: ${formatCoins(totalFined)}.` })
    pushLog(`👑 ${emperor.name}: ${emperor.scold} (−${formatCoins(taken)})`)
  })
  on(Events.IdleFineRecurring, ({ taken, emperor }) => {
    totalFined += taken
    postMessage({ key: 'idle', kind: 'urgent', type: 'IDLE', icon: '👑', title: `The Emperor demands his due · ${emperor.name} ${emperor.cn}`, text: emperor.recurring,
      action: `Another ${formatCoins(taken)} taken. Move the mouse, click or press any key now to stop it. Stolen so far: ${formatCoins(totalFined)}.` })
    pushLog(`👑 ${emperor.name}: ${emperor.recurring} (−${formatCoins(taken)})`)
  })
  on(Events.IdleResume, () => {
    if (totalFined > 0) pushLog(`You return to your kingdom. ${formatCoins(totalFined)} lost to the Emperor's claim.`)
    totalFined = 0
    resolveMessage('idle')
  })
}
